module.exports = d3;


//////////////////
// WEBPACK FOOTER
// external "d3"
// module id = 855
// module chunks = 0